// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Tournaments_containerTournaments__AoN0R{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap:20px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Tournaments/Tournaments.module.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ","sourcesContent":["\n.containerTournaments{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap:20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerTournaments": `Tournaments_containerTournaments__AoN0R`
};
export default ___CSS_LOADER_EXPORT___;
